import { Link } from 'react-router-dom';
import { useLanguage } from '@/context/LanguageContext';

const Privacy = () => {
  const { language } = useLanguage();
  const isEs = language === 'es';

  return (
    <div className="min-h-screen bg-zinc-950">
      <div className="max-w-2xl mx-auto px-6 py-12">
        <Link to="/" className="inline-block text-zinc-500 hover:text-white text-sm mb-8 transition-colors">
          ← {isEs ? 'Volver a Inker' : 'Back to Inker'}
        </Link>

        <h1 className="text-2xl font-bold text-white mb-6">
          {isEs ? 'Política de Privacidad' : 'Privacy Policy'}
        </h1>

        <p className="text-zinc-400 mb-8">
          {isEs
            ? 'Inker respeta tu privacidad. Esta política describe cómo recopilamos, usamos y protegemos tu información.'
            : 'Inker respects your privacy. This policy describes how we collect, use and protect your information.'}
        </p>

        <h2 className="text-lg font-semibold text-white mt-8 mb-3">
          {isEs ? 'Datos que recopilamos' : 'Data we collect'}
        </h2>
        <p className="text-zinc-400 mb-6">
          {isEs
            ? 'Recopilamos la información que proporcionas al registrarte (nombre, email, datos de perfil) y al usar la app (fotos, mensajes, citas).'
            : 'We collect the information you provide when registering (name, email, profile data) and when using the app (photos, messages, appointments).'}
        </p>

        <h2 className="text-lg font-semibold text-white mt-8 mb-3">
          {isEs ? 'Cómo los usamos' : 'How we use it'}
        </h2>
        <p className="text-zinc-400 mb-6">
          {isEs
            ? 'Tus datos se usan para ofrecer el servicio, personalizar tu experiencia y comunicarnos contigo. No vendemos tus datos a terceros.'
            : 'Your data is used to provide the service, personalize your experience and communicate with you. We do not sell your data to third parties.'}
        </p>

        <h2 className="text-lg font-semibold text-white mt-8 mb-3">
          {isEs ? 'Contacto' : 'Contact'}
        </h2>
        <p className="text-zinc-400">
          {isEs
            ? 'Para preguntas sobre privacidad, contáctanos a través de la app o en '
            : 'For questions about privacy, contact us through the app or at '}
          <a href="mailto:support@inker.app" className="text-white underline hover:no-underline">
            support@inker.app
          </a>
        </p>

        <p className="text-zinc-600 text-sm mt-12">
          {isEs ? 'Última actualización: Marzo 2025' : 'Last updated: March 2025'}
        </p>
      </div>
    </div>
  );
};

export default Privacy;
